// removed by extract-text-webpack-plugin
module.exports = {"hero":"hero__1Z8cY","text_container":"text_container__n_jXM","hero_title":"hero_title__1jo1i","belt":"belt__3Q0u3","home_info":"home_info__2R1Mw","text":"text__KcKgR","stats":"stats__1a5tI","action_button":"action_button__2mQvm","button_holder":"button_holder__1i7WI","stat":"stat__1AFaM","number":"number__S-T2l","label":"label__2WshR","partners":"partners__JqXZZ","sponsor":"sponsor__2Xiqv","item":"item__3r_cP","video":"video__2EC34","action_button_2":"action_button_2__2z__w"};


//////////////////
// WEBPACK FOOTER
// ./routes/home/style.css
// module id = ZAL5
// module chunks = 0